import { BillingModel } from '@futrli-sdk/app-store';
import { organisation } from '@futrli-sdk/organisations';

import { API_PATHS, ROUTE_PARAMS } from '../../app-core/constants';
import { interpolatePathParams } from '../../path';
import {
  API_REQUEST,
  getFromNormalisedStoreByPath,
  REQUEST_METHODS
} from '../../redux-helpers';
import {
  ACTIVATE_PRODUCT,
  GET_ORGANISATIONS,
  GET_ORGANISATION_BY_ID
} from '../core/constants';

export const getOrganisations = (workspaceId: string) => {
  const interpolated: string = interpolatePathParams(API_PATHS.ORGANISATIONS, {
    [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId
  });
  return getFromNormalisedStoreByPath(interpolated, GET_ORGANISATIONS, [organisation]);
};

export const getOrganisationById = (workspaceId: string, id: string) => {
  const interpolated: string = interpolatePathParams(API_PATHS.ORGANISATION_BY_ID, {
    [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId,
    [ROUTE_PARAMS.ORGANISATION_ID]: id
  });
  return getFromNormalisedStoreByPath(interpolated, GET_ORGANISATION_BY_ID, organisation);
};

export const activateProduct = (
  workspaceId: string,
  organisationId: string,
  productId: string,
  billingModel: BillingModel
) => {
  const interpolated: string = interpolatePathParams(API_PATHS.PRODUCT_SETUP, {
    [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId,
    [ROUTE_PARAMS.ORGANISATION_ID]: organisationId
  });

  return {
    type: ACTIVATE_PRODUCT.ACTION,
    payload: {
      request: {
        method: REQUEST_METHODS.PUT,
        url: interpolated,
        data: {
          product_id: productId,
          billing_model: billingModel
        }
      }
    },
    meta: {
      flag: API_REQUEST
    }
  };
};

